import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { IconButton, Stack, Typography } from "@mui/material";
import { ProjectStatus } from "../../../invitations/components/project-status";

function EventTooltipHeader({
  title,
  event,
  onClose,
}: {
  title: string;
  event: any;
  onClose: () => void;
}) {
  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      spacing={1}
    >
      <Stack spacing={1.25} sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          fontSize={16}
          fontWeight={700}
          color="#0F172A"
          lineHeight={1.3}
          noWrap
          title={title}
        >
          {title}
        </Typography>
        <ProjectStatus
          data={event}
          labelField="displayLabel"
          width="fit-content"
        />
      </Stack>
      <IconButton
        size="small"
        aria-label="Close meeting details"
        onClick={onClose}
        sx={{
          mt: -0.25,
          mr: -0.5,
          color: "#64748B",
          bgcolor: "#FFFFFF",
          border: "1px solid #E2E8F0",
          "&:hover": { bgcolor: "#F1F5F9" },
        }}
      >
        <CloseRoundedIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Stack>
  );
}

export { EventTooltipHeader };
